var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8098_61006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 19.4036 19.4036 25 12.5 25C5.59635 25 0 19.4036 0 12.5C0 5.59635 5.59635 0 12.5 0C19.4036 0 25 5.59635 25 12.5Z",
    fill: "#0EA3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0602 23.2044C15.731 21.1773 14.3465 18.3811 14.3465 18.3811C14.3465 18.3811 9.74865 10.6546 9.12628 10.6546C5.28831 8.10832 7.50504 1.07497 7.5182 1.0332C3.0941 2.95791 0 7.36846 0 12.5009C0 19.0838 5.08842 24.4781 11.5467 24.9651C11.8322 24.3881 12.3028 23.7793 13.0602 23.2044Z",
    fill: "#3FB6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79395 10.9256L11.7569 9.54063H14.1747L13.4186 7.46312H11.6184V6.07812H14.3884L15.1445 8.15562H17.8509V10.2331H15.9006L16.9094 13.0046C18.5855 13.056 19.9284 14.4309 19.9284 16.1194C19.9284 17.8404 18.5332 19.2356 16.8121 19.2356C15.091 19.2356 13.6959 17.8404 13.6959 16.1194C13.6959 14.8536 14.4505 13.7641 15.5344 13.2762L14.6788 10.9256H14.0226L12.9272 14.9906L10.9019 15.7308C10.9177 15.8581 10.9259 15.9878 10.9259 16.1194C10.9259 17.8404 9.53067 19.2356 7.80961 19.2356C6.08855 19.2356 4.69336 17.8404 4.69336 16.1194C4.69336 14.7626 5.56051 13.6082 6.77086 13.1805V12.3106H5.38586V10.9256H9.79395ZM7.80961 17.8506C8.76575 17.8506 9.54086 17.0755 9.54086 16.1194C9.54086 15.1632 8.76575 14.3881 7.80961 14.3881C6.85347 14.3881 6.07836 15.1632 6.07836 16.1194C6.07836 17.0755 6.85347 17.8506 7.80961 17.8506ZM16.8121 17.8506C17.7682 17.8506 18.5434 17.0755 18.5434 16.1194C18.5434 15.1632 17.7682 14.3881 16.8121 14.3881C15.856 14.3881 15.0809 15.1632 15.0809 16.1194C15.0809 17.0755 15.856 17.8506 16.8121 17.8506Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8098_61006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRider);
export default __webpack_public_path__ + "static/media/rider.92fd0d085db94e2197ba21e89375fe06.svg";
export { ForwardRef as ReactComponent };